module.exports = __webpack_public_path__ + "img/flags.59409e8e.png";